/**
 * Formatação de data/hora usada nas bolhas de mensagem dos dois chats.
 *
 * O carimbo mostra sempre dia e mês junto da hora. Só a hora bastava enquanto a conversa
 * cabia numa tela, mas o atendente abre protocolos de dias atrás e o cliente rola o
 * histórico: "15:04" sem data não diz se foi hoje ou na terça passada.
 */
export function carimboDaMensagem(quando) {
    const data = quando instanceof Date ? quando : new Date(quando);
    if (Number.isNaN(data.getTime()))
        return '';
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const hora = String(data.getHours()).padStart(2, '0');
    const minuto = String(data.getMinutes()).padStart(2, '0');
    return `${dia}/${mes} ${hora}:${minuto}`;
}
/**
 * O rótulo da faixa que separa os dias dentro da conversa: "Hoje", "Ontem" ou a data.
 *
 * Existe porque rolar uma conversa longa sem marco nenhum deixa quem lê sem saber se
 * aquilo foi de manhã ou na semana passada — o carimbo da bolha diz dia e mês, mas em
 * letra miúda e repetido em cada linha, que é justamente o que o olho ignora.
 *
 * No fuso de quem lê, e não no da empresa: a faixa tem que concordar com a hora escrita
 * na bolha ao lado, que sai do relógio do navegador. Fosse diferente, uma mensagem das
 * 23h apareceria sob "Hoje" com hora de ontem.
 */
export function rotuloDoDia(quando, agora = new Date()) {
    const data = quando instanceof Date ? quando : new Date(quando);
    if (Number.isNaN(data.getTime()))
        return '';
    const diferenca = diasEntre(data, agora);
    if (diferenca === 0)
        return 'Hoje';
    if (diferenca === 1)
        return 'Ontem';
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    return `${dia}/${mes}/${data.getFullYear()}`;
}
/** As duas datas caem no mesmo dia civil de quem está lendo? */
export function mesmoDia(a, b) {
    const um = a instanceof Date ? a : new Date(a);
    const outro = b instanceof Date ? b : new Date(b);
    if (Number.isNaN(um.getTime()) || Number.isNaN(outro.getTime()))
        return false;
    return (um.getFullYear() === outro.getFullYear() &&
        um.getMonth() === outro.getMonth() &&
        um.getDate() === outro.getDate());
}
/**
 * Quantos dias civis separam as duas datas.
 *
 * Conta pela data do calendário, e não por 24 horas corridas: 23h de ontem e 1h de hoje
 * são duas horas de diferença e um dia de distância — e é o dia que a faixa mostra.
 * Subtrair milissegundos erraria isso, e erraria de novo no dia em que o horário de verão
 * voltar a existir.
 */
function diasEntre(data, referencia) {
    const umDia = 24 * 60 * 60 * 1000;
    const inicioDe = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    return Math.round((inicioDe(referencia) - inicioDe(data)) / umDia);
}
//# sourceMappingURL=datas.js.map